import headerPhoto1 from '../../../../../shared/assets/photo/header/1.jpg';
import headerPhoto2 from '../../../../../shared/assets/photo/header/2.jpg';
import headerPhoto3 from '../../../../../shared/assets/photo/header/3.jpg';
import headerPhoto4 from '../../../../../shared/assets/photo/header/4.jpg';
import headerPhoto5 from '../../../../../shared/assets/photo/header/5.jpg';

import vertical1 from '../../../../../shared/assets/photo/header/6.jpg';
import vertical2 from '../../../../../shared/assets/photo/header/7.jpg';
import vertical3 from '../../../../../shared/assets/photo/header/8.jpg';
import vertical4 from '../../../../../shared/assets/photo/header/9.jpg';
import vertical5 from '../../../../../shared/assets/photo/header/10.jpg';

export const headerData = [
    {
        id: 1,
        src: headerPhoto1
    },
    {
        id: 2,
        src: headerPhoto2
    },
    {
        id: 3,
        src: headerPhoto3
    },
    {
        id: 4,
        src: headerPhoto4
    },
    {
        id: 5,
        src: headerPhoto5
    },
  
];

export const verticalHeaderData = [
    {
        id: 1,
        vertPhoto: vertical1
    },
    {
        id: 2,
        vertPhoto: vertical2
    },
    {
        id: 3,
        vertPhoto: vertical3
    },
    {
        id: 4,
        vertPhoto: vertical4
    },
    {
        id: 5,
        vertPhoto: vertical5
    },
  
];